import { Component, Injector } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';

@Component({
    selector: 'app-noticetriggersets',
    templateUrl: './noticetriggersets.component.html',
    styleUrls: ['./noticetriggersets.component.scss'],
    standalone: false
})
export class NoticeTriggerSetsComponent extends ModelEditor {
  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Set Name', 'Name'),
    new Datalistviewcolumn('Triggers', 'TriggerCount'),
  ];

  constructor(injector: Injector) {
    super("enforcement/noticetriggersets", injector);

    // This is a list page, not an edit page. Do not let ModelEditor auto-load a model.
    this.ReactiveFormsEnabled = false;
    this.BlockLoading = true;
  }

  public override ngOnInit(): void
  {
    // Intentionally do NOT call super.ngOnInit() - no model fetch on list pages.
  }

  // --- ModelEditor requirements (not used on list pages) ---
  public override DefaultModel(): any { return {}; }
  public override AfterModelLoaded(): void { }
  public override BeforeSave(): boolean | void { return false; }
  public override Validators(): any { return {}; }
}

